import { handleActions } from 'redux-actions'
import * as rawActions from '../actions'

export default handleActions(
  {
    [rawActions.openBentleyAnalyticsReportDialog](state, action) {
      return true
    },
    [rawActions.closeBentleyAnalyticsReportDialog](state, action) {
      return false
    },
    [rawActions.resetState](state, action) {
      return false
    },
  },
  false
)
